import  {NotificationSettingsItem}  from "./NotificationSettingsItem";

export default NotificationSettingsItem;